<div class="row">
	<div class="col-md-2"></div>
		<div class="col-md-8">
			<video width="100%" height="auto" controls autoplay>
			  <source src="/assets/videos/Sleep_Environment.mp4" type="video/mp4">
			Your browser does not support the video tag.
			</video>
		</div>
	    <div class="col-md-2"></div>
		<div class="col-md-2"></div>
		<div class="col-md-8">
		 <p style="color : #002E46 !important;">
		 Before you start the CBTI program make sure to optimize your sleep environment. 
		 </p>
		 <p style="color : #002E46 !important;">
		 Is your sleep environment playing a role in your insomnia? 
		 </p>
		 <p style="color : #002E46 !important;">
		 If you are having trouble sleeping, the last thing you need is environmental stimuli, such as noises, distractions, or light peeking through your curtains, interfering with your sleep. 
		 </p>
		 <p style="color : #002E46 !important;">
		 So, let’s review some fundamental to keep in mind
		 </p>
		 <p style="color : #002E46 !important;">
		 First, <b>make sure that your room is as dark as possible</b>. Remove any lights and get heavy curtains or blinds to eliminate outside light. This applies to your pre-bedtime routine too: avoid bright fluorescent lights, dimming the lights is a good idea. The reason for this is that darkness stimulates melatonin secretion which is the hormone that promotes sleep. 
		 </p>
		 <p style="color : #002E46 !important;">
		 Next, <b>make sure your room is quiet</b>, eliminate noise coming into your room as much as you can. Of course, some noises, such as neighbors and traffic, are outside of your control. If these noises disrupt your sleep, consider investing in a white sound machine to make the sound that is present in your room more consistent. It is often inconsistent noises that cause sleep disruption. 
		 </p>
		 <p style="color : #002E46 !important;">
		 <b>Room temperature can also affect your sleep</b>. Studies have shown that an ideal sleep temperature is either not too cold or too hot, the optimal temperature for sleep should be between 16-21 C. 
		 </p>
		 <p style="color : #002E46 !important;">
		 <b>People’s preferences in mattresses </b>and how well they sleep on different surfaces vary widely. Make sure that your bed is comfortable. Try to find a mattress that is comfortable for you and make your bedroom as comfortable as possible.
		 </p>
		 <p style="color : #002E46 !important;">
		 <b>Although sleeping with pets brings many people joy, some people experience disturbed sleep</b> because of allowing their pet in their bedroom at night. Like humans, animals have a circadian rhythm so try to keep a consistent bedtime routine so that your pet is in sync with you. 
		 </p>
		 <p style="color : #002E46 !important;">
		 In addition to these obvious environmental factors, other aspects of your sleeping situation can also play a role in how well you sleep. To the extent possible, you want to clean out clutter from your room that can serve as potential distractions. 
		 </p>
		 <p style="color : #002E46 !important;">
		 <b>Avoid working or watching TV in your sleeping environment</b>, as well as the use of any electronics. If you use your phone as a clock or an alarm, consider buying a clock specifically designed for that purpose and leave your phone out of your bedroom.
		 </p>
		 <p style="color : #002E46 !important;">
		 Finally <b>assess your own sleep environment</b> and determine if you might need to make some changes to it. In the end these changes will improve sleep and promote a more restful night sleep.
		 </p>
		 <p style="color : #002E46 !important;">
		 
		 </p>
		</div>
		
	<div class="col-md-2"></div>

</div>







